import client from './client'

let attendeesService = {}

attendeesService.getAccessTypesList = async function() {
  try {
    const res = await client.get('/attendees/access-types/')
    return res.data
  } catch (error) {
    return error
  }
}

attendeesService.createAttendee = async function(payload) {
  try {
    const res = await client.post('/attendees/', payload)
    return res.data
  } catch (error) {
    return error
  }
}

export default attendeesService
